/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Inject, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { emit } from "process";
import { SlotService } from "src/app/services/slot/slot.service";
@Component({
  selector: "app-download-dialog",
  templateUrl: "./download-dialog.component.html",
  styleUrls: ["./download-dialog.component.scss"],
})
export class DownloadDialogComponent implements OnInit {
  onYes = new EventEmitter();
  onCancel = new EventEmitter();
  onBreak = new EventEmitter();
  displayString: String;
  buttonFlag;
  whiteBackground;
  check: Boolean = false;
  isMobileDevice = false;
  progress;
  width;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public slotService: SlotService,
    public router: Router,
    public dialogRef: MatDialogRef<DownloadDialogComponent>
  ) {
    if (data.progress === 0) {
      console.log("this.progress", data.progress);
      this.progress = 0;
      this.width = 0;
    }
    // display flag 7 is used for c2c video call
    if (data.displayFlag === 0) {
      this.displayString = "Are you sure you want to leave the meeting ?";
    } else if (data.displayFlag === 1) {
      this.displayString =
        "Cart has unsaved items.<br/>Do you want to save the cart?";
    } else if (data.displayFlag === 2) {
      this.whiteBackground = true;
      this.displayString = "Do you want to download the recorded video ?";
    } else if (data.displayFlag === 3) {
      this.displayString = "You clicked to end the meeting. Please confirm.";
    } else if (data.displayFlag === 4) {
      //this.displayString = "You clicked to exit the meeting. Please confirm.";
      this.displayString = "Do you want to exit from the call?";
    } else if (data.displayFlag === 5) {
      this.displayString = "Are you sure you want to remove this user ?";
    } else if (data.displayFlag === 6) {
      if (data.clickToCall) {
        this.displayString = "Do you want to exit from the call?";
      } else if (data.isClickToCallFlag) {
        this.displayString = "Do you want to complete the call for customer?";
      } else {
        this.displayString =
          "Do you want to complete the appointment for customer ?";
      }
    } else if (data.displayFlag === 8) {
      this.whiteBackground = true;
      this.displayString =
        "Are you sure you want to change filters. Previous data will be lost?";
    }
    this.buttonFlag = data.buttonFlag;
    this.isMobileDevice = data.isMobileDevice;
    console.log(this.buttonFlag, data.displayFlag, data);
  }

  ngOnInit(): void {}
  yesClicked() {
    this.onYes.emit();
    if (this.data.displayFlag === 8) {
      this.dialogRef.close();
    }
  }
  cancelClicked() {
    this.onCancel.emit();
    if (this.data.displayFlag === 8) {
      this.dialogRef.close();
    }
  }
  clickedBreak(type) {
    switch (type) {
      case 0:
        {
          this.onBreak.emit(0);
        }
        break;
      case 1:
        {
          this.onBreak.emit(1);
        }
        break;
      case 2:
        {
          this.onBreak.emit(2);
        }
        break;
      case 3:
        {
          this.onBreak.emit(3);
        }
        break;
      default: {
        this.onBreak.emit(2);
      }
    }
  }
  hideClicked() {
    this.dialogRef.close();
  }
  isVideoCall() {
    return this.router.url.includes("liveshop");
  }
}
